import { useEffect, useState } from 'react'
import { fetchSourceSummaries } from '@/api/content/refs'
import type { SourceSummary } from '@/api/content/refs'

type SourceSummaryLoader = (docIds: Array<number>) => Promise<Array<SourceSummary>>

export function useSourceDocumentLabel({
  docId,
  absentLabel,
  load = fetchSourceSummaries
}: {
  docId: number | null | undefined
  absentLabel: string
  load?: SourceSummaryLoader
}): string {
  const [resolved, setResolved] = useState<{ docId: number; label: string }>()

  useEffect(() => {
    if (docId == null) return
    let cancelled = false
    void load([docId])
      .then((summaries) => {
        if (cancelled) return
        const summary = summaries.find((candidate) => candidate.docId === docId)
        setResolved({ docId, label: summary?.fileName || 'Template unavailable' })
      })
      .catch(() => {
        if (!cancelled) setResolved({ docId, label: 'Template unavailable' })
      })
    return () => {
      cancelled = true
    }
  }, [docId, load])

  if (docId == null) return absentLabel
  return resolved?.docId === docId ? resolved.label : 'Loading template'
}
